module.exports = __webpack_public_path__ + "img/avatar-2.e318c63a.png";